import { CompetitionResult } from "../interfaces/ICompetitions";
import { findCompetitionResultById, subscribeCompetitionResultById } from "../utils/firestore";
import { useCallback, useEffect, useState } from "react";

export const useCompetition = (competitionId: string | undefined) => {
  const [competition, setCompetition] = useState<CompetitionResult | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refreshData = useCallback(async () => {
    if (!competitionId) {
      setCompetition(null);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const data = await findCompetitionResultById(competitionId);
      setCompetition(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Wystąpił błąd");
    } finally {
      setLoading(false);
    }
  }, [competitionId]);

  useEffect(() => {
    if (!competitionId) {
      setCompetition(null);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    const unsubscribe = subscribeCompetitionResultById(
      competitionId,
      (data) => {
        setCompetition(data);
        setLoading(false);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      },
    );

    return () => unsubscribe();
  }, [competitionId]);

  return { competition, loading, error, refreshCompetition: refreshData };
};
